var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 5.5,
    stroke: "white",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2212 11.8244C18.9937 11.7994 18.7675 11.7819 18.5375 11.7819C15.1763 11.7819 12.5212 14.2919 12.52 17.3844C12.52 17.9007 12.6013 18.3956 12.7387 18.8694C12.5212 18.8856 12.3012 18.8956 12.0788 18.8956C11.3391 18.8956 10.7211 18.7695 10.0203 18.6266C9.88386 18.5987 9.74426 18.5702 9.6 18.5419L7.125 19.7819L7.8325 17.6531C6.06 16.4131 5 14.8169 5 12.8731C5 9.5044 8.1875 6.85315 12.0788 6.85315C15.56 6.85315 18.6087 8.9719 19.2212 11.8244ZM15.6187 10.7469C15.6187 10.2144 15.2675 9.86315 14.7325 9.86315C14.2025 9.86315 13.6712 10.2131 13.6712 10.7469C13.6712 11.2769 14.2037 11.6319 14.7325 11.6319C15.2675 11.6319 15.6187 11.2769 15.6187 10.7469ZM8.7125 10.7469C8.7125 11.2769 9.2475 11.6319 9.77875 11.6319C10.31 11.6319 10.6625 11.2769 10.6625 10.7469C10.6625 10.2131 10.31 9.86315 9.77875 9.86315C9.2475 9.86315 8.7125 10.2144 8.7125 10.7469ZM18.9863 12.1631C22.1676 12.1631 25.0001 14.4694 25.0001 17.2994C25.0001 18.8956 23.9401 20.3094 22.5188 21.3769L23.0513 23.1469L21.1101 22.0819C20.4026 22.2594 19.6913 22.4356 18.9863 22.4356C15.6188 22.4356 12.9663 20.1369 12.9663 17.2994C12.9663 14.4706 15.6176 12.1631 18.9863 12.1631ZM16.3263 15.7056C16.3263 16.0631 16.6826 16.4131 17.0338 16.4131C17.5713 16.4131 17.9201 16.0631 17.9201 15.7056C17.9201 15.3531 17.5713 14.9981 17.0338 14.9981C16.6826 14.9981 16.3263 15.3531 16.3263 15.7056ZM20.2238 15.7056C20.2238 16.0631 20.5788 16.4131 20.9276 16.4131C21.4601 16.4131 21.8138 16.0631 21.8138 15.7056C21.8138 15.3531 21.4601 14.9981 20.9276 14.9981C20.5776 14.9981 20.2238 15.3531 20.2238 15.7056Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWx);
export default __webpack_public_path__ + "static/media/icon_wx.c28809e7c48bf752f943927d93db1231.svg";
export { ForwardRef as ReactComponent };